import excelToJson from '/utils/convert-excel-to-json.js'
import _ from 'lodash'
import getLeafNodes from '/utils/get-leaf-nodes'

const parseUploadedData = ({ base64Data, file, variables, requireJsonArray = false }) => {

  try {
    const filetype = file.name.split(".").pop()

    let content

    switch (filetype) {
      case "xlsx": {
        const leafNodes = getLeafNodes(variables)

        let emptyVariables = {}
        leafNodes.map(n => _.set(emptyVariables, n, null))

        const buffer = Buffer.from(base64Data, "base64")
        const ed = excelToJson({ source: buffer, type: "buffer" })
        const sheets = Object.keys(ed)
        const structuredData = ed[sheets[0]]

        let sheetrows = []

        let type = "header"

        structuredData.map(i => {
          if (i.A === '-- -- -- -- --') {
            type = "body"
          } else {
            if (type === "body") {
              const keys = Object.keys(i)
              let allValues = ""

              for (let k in keys) allValues += i[keys[k]]

              if (allValues.length) sheetrows.push(i)
            }
          }
        })


        content = sheetrows.map(row => {
          let item = _.cloneDeep(emptyVariables)

          for (let letter in row) {
            _.set(item, leafNodes[letterToLeafNodeIndex(letter)], row[letter])
          }
          return item
        })

        break
      }

      case "csv": {
        const data = atob(base64Data)

        const leafNodes = getLeafNodes(variables)

        content = []

        const rows = data.split("\n")
        let header = rows.shift()
        header = header.split(",")

        rows.map(r => {
          const row = r.split(",")

          let data_item = {}

          row.map((item, idx) => {
            _.set(data_item, leafNodes[idx], item)
          })
          content.push(data_item)
        })

        break
      }

      case "json": {
        const data = atob(base64Data)
        content = JSON.parse(data)
        if (requireJsonArray && !Array.isArray(content)) {
          throw new Error("JSON upload must be an array of pass variable objects.")
        }
        break
      }
    }

    // We need an array. Make one here if user uploaded a single pass JSON object
    if (!Array.isArray(content)) content = [content]

    return content
  }
  catch (err) {
    console.log(err)
  }
}

export default parseUploadedData

const letterToLeafNodeIndex = letters => {
  const splitLetters = letters.split("")
  let index = 0

  splitLetters.map(l => index += l.charCodeAt(0) - 64)

  return index - 1

}
